import {FC} from 'react';

import {Add} from '@mui/icons-material';
import {Box, IconButton, SxProps, Typography} from '@mui/material';

import {greenColors, orangeColors} from '../../layouts/theme/designSystem';

interface EmpionAddableButtonProps {
  label: string;
  color?: 'primary' | 'secondary';
  sx?: SxProps;
  onAdd?: () => void;
}

const EmpionAddableButton: FC<EmpionAddableButtonProps> = ({label, sx, color, onAdd}) => {
  const isSecondary = color === 'secondary';
  const textColor = (() => {
    if (isSecondary) {
      return orangeColors[900];
    }
    return greenColors[700];
  })();
  return (
    <Box
      sx={{
        backgroundColor: orangeColors[3],
        display: 'inline-block',
        padding: '4px 8px 4px 16px',
        borderRadius: '2px',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: orangeColors[4],
        },
        ...sx,
      }}
      onClick={onAdd}
      data-testid={label + '-addable-button'}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography color={textColor} variant='body1'>
          {label}
        </Typography>
        {onAdd != null && (
          <IconButton
            sx={{
              color: orangeColors[900],
            }}
            data-testid={label + '-addable-button-close'}
          >
            <Add
              sx={{
                fontSize: '24px',
              }}
            />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

export default EmpionAddableButton;
